module.exports = __webpack_public_path__ + "media/ringtone.c95aa8e7.wav";